import { resolveIntegrationContent, type IntegrationContent } from './integration-content-data';

/** Database product descriptions, never an individual connection's grants. */
export function getIntegrationDisclosure(tool: string, rows: readonly IntegrationContent[], locale: string) {
  const content = resolveIntegrationContent(rows, tool, locale);
  if (!content) return null;
  return {
    purpose: content.description,
    capabilitySource: content.appKey === 'custom_mcp' ? ('discovered' as const) : ('catalog' as const),
    read: content.readCapabilities,
    write: content.writeCapabilities,
    hasCatalog: content.readCapabilities.length + content.writeCapabilities.length > 0,
  };
}

export function getConnectionPrivacyPolicyUrl(isPlugin: boolean) {
  return isPlugin
    ? 'https://www.bizsidekick.app/privacy'
    : 'https://www.bustly.ai/privacy';
}
